import dayjs from "dayjs";
import { FC } from "react";
import WeekDayWeather from "./weekDaySections/weekDayWeather/weekDayWeather";
import WeekDayPublicHolidays from "./weekDaySections/weekDayPublicHoliday/weekDayPublicHolidays";
import WeekDaySiteEvents from "./weekDaySections/weekDaySiteEvents/weekDaySiteEvents";
import WeekDayRevenue from "./weekDaySections/weekDayRevenue/weekDayRevenue";
import WeekDayForecastMetrics from "./weekDaySections/weekDayForecastMetrics/weekDayForecastMetrics";
import "./weekDay.css";

type WeekDayProps = {
  day: dayjs.Dayjs;
};

const WeekDay: FC<WeekDayProps> = ({ day }) => {
  return (
    <div className="week-calendar-day">
      <div className="week-day-revenue-summary">
        <WeekDayRevenue day={day} />
      </div>
      <div className="week-day-forecast-metrics-summary">
        <WeekDayForecastMetrics day={day} />
      </div>
      <div className="week-day-site-events-summary">
        <WeekDaySiteEvents day={day} />
      </div>
      <div className="week-day-public-holiday-summary">
        <WeekDayPublicHolidays day={day} />
      </div>
      <div className="week-day-weather-summary">
        <WeekDayWeather day={day} />
      </div>
    </div>
  );
};

export default WeekDay;
